import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, GenericReportFiltersDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetGenericReportTotalCommand extends IRequestCommand<
  IGetGenericReportResponse,
  ErrorDetails,
  IGetGenericReportParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl =
    'data/genericReport/{reportCode}/totals?page={page}&size={size}&column={column}&sort={sort}';

  public override setParameters(parameters: IGetGenericReportParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{reportCode}',
      parameters.reportCode ? parameters.reportCode.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{page}',
      parameters.page ? parameters.page.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{size}',
      parameters.size ? parameters.size.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{column}',
      parameters.column ? parameters.column.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{sort}',
      parameters.sort ? parameters.sort.toString() : ''
    );
    this._commandBody = parameters;
  }
}

export interface IGetGenericReportParameters {
  page?: number;
  size?: number;
  column?: string;
  sort?: string;
  reportCode?: string;
  filters: Array<GenericReportFiltersDTO>;
}

export interface IGetGenericReportResponse
  extends ICommandResponse,
    GenericReportFiltersDTO {}
